/**
 * Suppliers Form - Manejo de formularios de creación y edición de proveedores
 */
export class SuppliersForm {
    constructor() {
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeForm();
            });
        }
        else {
            this.initializeForm();
        }
    }
    initializeForm() {
        const supplierForm = document.getElementById('supplierForm');
        if (!supplierForm) {
            return;
        }
        this.setupEventListeners();
        this.setupRfcFormatter();
    }
    setupEventListeners() {
        // Validación del formulario
        const supplierForm = document.getElementById('supplierForm');
        if (supplierForm) {
            supplierForm.addEventListener('submit', (e) => this.handleFormSubmit(e));
        }
    }
    setupRfcFormatter() {
        const rfcInput = document.getElementById('tax_id');
        if (!rfcInput) {
            return;
        }
        // Formatear RFC a mayúsculas automáticamente
        rfcInput.addEventListener('input', (e) => {
            const target = e.target;
            target.value = target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        });
        // Validar longitud del RFC (12 para personas morales, 13 para físicas)
        rfcInput.addEventListener('blur', (e) => {
            const target = e.target;
            const rfc = target.value.trim();
            if (rfc.length > 0 && rfc.length !== 12 && rfc.length !== 13) {
                this.showFieldError('tax_id', 'El RFC debe tener 12 (persona moral) o 13 (persona física) caracteres.');
            }
            else {
                this.clearFieldError('tax_id');
            }
        });
    }
    handleFormSubmit(e) {
        const rfcInput = document.getElementById('tax_id');
        const nameInput = document.getElementById('name_tax_id');
        if (!rfcInput || !nameInput) {
            return;
        }
        const rfc = rfcInput.value.trim();
        const name = nameInput.value.trim();
        // Validar RFC
        if (rfc === '') {
            e.preventDefault();
            this.showAlert('Por favor ingresa el RFC del proveedor.', 'danger');
            rfcInput.focus();
            return;
        }
        if (rfc.length !== 12 && rfc.length !== 13) {
            e.preventDefault();
            this.showAlert('El RFC debe tener 12 (persona moral) o 13 (persona física) caracteres.', 'danger');
            rfcInput.focus();
            return;
        }
        // Validar nombre
        if (name === '') {
            e.preventDefault();
            this.showAlert('Por favor ingresa el nombre del proveedor.', 'danger');
            nameInput.focus();
            return;
        }
        if (name.length < 3) {
            e.preventDefault();
            this.showAlert('El nombre del proveedor debe tener al menos 3 caracteres.', 'danger');
            nameInput.focus();
            return;
        }
    }
    showFieldError(fieldId, message) {
        const field = document.getElementById(fieldId);
        if (!field) {
            return;
        }
        // Remove existing error
        this.clearFieldError(fieldId);
        // Add error class
        field.classList.add('is-invalid');
        // Create error message
        const errorDiv = document.createElement('div');
        errorDiv.className = 'invalid-feedback';
        errorDiv.id = `${fieldId}-error`;
        errorDiv.textContent = message;
        // Insert error after the input
        field.parentNode?.insertBefore(errorDiv, field.nextSibling);
    }
    clearFieldError(fieldId) {
        const field = document.getElementById(fieldId);
        if (!field) {
            return;
        }
        field.classList.remove('is-invalid');
        const errorDiv = document.getElementById(`${fieldId}-error`);
        if (errorDiv) {
            errorDiv.remove();
        }
    }
    showAlert(message, type) {
        // Crear elemento de alerta
        const alertDiv = document.createElement('div');
        alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
        alertDiv.setAttribute('role', 'alert');
        alertDiv.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;
        // Insertar al inicio del formulario
        const form = document.getElementById('supplierForm');
        if (form) {
            form.insertBefore(alertDiv, form.firstChild);
            // Auto-cerrar después de 5 segundos
            setTimeout(() => {
                alertDiv.remove();
            }, 5000);
        }
    }
}
export default SuppliersForm;
